import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../images/logo-2.svg";
import { useTranslation } from "react-i18next";
import { useLang } from "../../context/LangContext";
import { useServicesList } from "../../api/Services";
import { useConfig } from "../../hooks/useConfig";
import { APP_VERSION } from "../../version";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

// Removed unused SubmitHandler as we replaced newsletter with contact info

const Footer = (props) => {
  const { t } = useTranslation();
  const { lang } = useLang();
  const config = useConfig();

  const servicesList = useServicesList();
  return (
    <footer className="site-footer arabic-font">
      <div className={`upper-footer ${props.ftClass}`}>
        <div className="container">
          <div className="row">
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <img src={Logo} alt="blog" />
                </div>
                <p>{t(`footerText`)}</p>
                <div className="social-widget">
                  <ul>
                    {config.getSocialMediaLinks().map((social, index) => (
                      <li key={index}>
                        <a
                          href={social.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={`${social.platform} profile`}
                        >
                          <i className={social.icon}></i>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3 className="title">{t(`ourServices`)}</h3>
                </div>
                <ul>
                  {servicesList.length > 0 &&
                    servicesList.slice(0, 6).map((service, Sitem) => (
                      <li key={Sitem}>
                        <Link
                          onClick={ClickHandler}
                          to={`/service-single/${service.slug}`}
                        >
                          {lang === "ar" ? service.titleAr : service.title}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget s2">
                <div className="widget-title">
                  <h3 className="title">{t(`quickLinks`)}</h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/home">
                      {t(`home`)}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/about">
                      {t(`aboutUs`)}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/services">
                      {t(`ourServices`)}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/about">
                      {t(`aboutUs`)}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="lower-footer">
        <div className="container">
          <div className="row g-0">
            <div className="col col-lg-6 col-12">
              <p className="copyright">
                {" "}
                {t(`copyRight`)}{" "}
                <Link onClick={ClickHandler} to="/">
                  {t(`matjarAlharam`)}{" "}
                </Link>
                . {t(`allRightReserved`)}{" "}
                <span className="app-version">v{APP_VERSION}</span>
              </p>
            </div>
            <div className="col col-lg-6 col-12">
              <ul>
                <li>
                  <Link onClick={ClickHandler} to="/contact">
                    {t(`privacy`)}
                  </Link>
                </li>
                <li>
                  <Link onClick={ClickHandler} to="/contact">
                    {t(`terms`)}
                  </Link>
                </li>
                <li>
                  <Link onClick={ClickHandler} to="/about">
                    {t(`aboutUs`)}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
